
query checkGeoblock($location: String) {
    checkGeoblock(location: $location)
}
